import {Injectable, Inject} from '@angular/core';
import {GlobalCacheService} from './global-cache.service';
import {Title, Meta, DomSanitizer} from '@angular/platform-browser';
import {PLATFORM_ID} from '@angular/core';
import {DOCUMENT, isPlatformBrowser, isPlatformServer} from '@angular/common';
import {UtilService} from '../utils/util.service';
import {globalConst} from '../constant/constant';
import {TypeFn} from '../utils/utils';

@Injectable({
  providedIn: 'root'
})
export class CommonServiceService {

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private globalCacheService: GlobalCacheService,
    public utilService: UtilService,
    @Inject(PLATFORM_ID) private platformId,
    @Inject(DOCUMENT) private document: Document,
  ) {
  }

  public typeFn = new TypeFn();

  pageAttribute(pagesTitleData): void {
    // const title = this.titleService.getTitle();
    // const keywords: HTMLMetaElement = this.metaService.getTag('name="keywords"');
    // const description: HTMLMetaElement = this.metaService.getTag('name="description"');
    // const author: HTMLMetaElement = this.metaService.getTag('name="author"');

    try {
      // 动态设置title
      this.titleService.setTitle(this.transformPageTitle(pagesTitleData?.title || ''));
      // 设置页面的meta关键字信息
      this.metaService.updateTag({name: 'keywords', content: pagesTitleData?.keywords || ''});
      // 设置页面的meta关键字信息
      this.metaService.updateTag({name: 'description', content: pagesTitleData?.description || ''});
      // 设置页面的meta关键字信息
      this.metaService.updateTag({name: 'author', content: pagesTitleData?.author || ''});
      // 设置网页背景
      this.setBodyBackgroundImage(pagesTitleData?.bodyBackgroundImage || '', pagesTitleData?.backgroundColor || '');
    } catch (error) {
      console.log('🚀 ~ file: common-service.service.ts ~ line 52 ~ error', error);
    }
  }

  // 设置网页背景
  setBodyBackgroundImage(image, color): any {
    if (isPlatformBrowser(this.platformId)) {
      // 仅在浏览器运行;
      if (image) {
        this.document.body.style.background = `url('${image}')`;
        this.document.body.style.height = '100vh';
        this.document.body.style.backgroundRepeat = 'no-repeat';
        this.document.body.style.backgroundPosition = 'center';
        this.document.body.style.backgroundSize = 'cover';
        this.document.body.style.backgroundAttachment = 'fixed';
      } else {
        this.document.body.style.backgroundImage = 'none';
      }
      if (color) {
        this.document.body.style.backgroundColor = color;
      } else {
        this.document.body.style.backgroundColor = 'none';
      }
    } else if (isPlatformServer(this.platformId)) {
      // 仅在服务端运行;
    }
  }

  // 设置网页favicon
  setFavicon(): any {
    const merchantConfig = this.getLocalStorageByKey('merchantConfig', {});
    const styleConfig = merchantConfig.websiteConfig || {};
    const favicon = styleConfig.pcFavicon ? styleConfig.pcFavicon : globalConst?.System_Config?.favicon || '';
    // 设置搜索结果中显示网站的图标
    this.metaService.updateTag({itemprop: 'image', content: favicon});
    this.document.getElementById('appFavicon').setAttribute('href', favicon);
  }

  /**
   * 商户   merchant
   * 导航栏 navigation
   * 文章   article
   * @param data `${merchant.companyName}-${navigation.title}-${article.title}`
   */
  transformPageTitle(data): any {
    if (data) {
      const merchant = this.getLocalStorageByKey('merchant');
      const navigation = this.getLocalStorageByKey('navigation');
      const article = this.globalCacheService.article;
      try {
        // tslint:disable-next-line:no-eval
        const title = eval(data).split('-');
        const titleValue = [];
        const regExp = new RegExp('(,)', 'g');
        for (const iterator of title) {
          if (iterator !== 'undefined' && iterator !== '') {
            titleValue.push(iterator);
          }
        }
        return titleValue.toString().replace(regExp, '-');
      } catch (error) {
        console.log(error);
        if (typeof data === 'string') {
          return data;
        }
      }
    }
  }

  // 设置 localStorage
  setLocalStorageByKey(key, value): void {
    try {
      if (isPlatformBrowser(this.platformId)) {
        // 仅在浏览器运行;
        localStorage.setItem(key, JSON.stringify(value));
      } else if (isPlatformServer(this.platformId)) {
        // 仅在服务端运行;
        this.globalCacheService[key] = value;
      }
    } catch (error) {
      console.log('getLocalStorageByKey', {key, value, error});
    }
  }

  // 获取 localStorage
  getLocalStorageByKey(key, defaultValue = null): any {
    try {
      if (isPlatformBrowser(this.platformId)) {
        // 仅在浏览器运行;
        return this.utilService.getJSONParse(localStorage.getItem(key) || defaultValue, defaultValue);
      } else if (isPlatformServer(this.platformId)) {
        // 仅在服务端运行;
        return this.globalCacheService[key] || defaultValue;
      }
    } catch (error) {
      console.log('getLocalStorageByKey', {key, error});
    }
  }

  /**
   * 删除 localStorage
   * @param keys 支持删除多个  传入 'all' 则删除全部
   *
   */
  removeLocalStorageByKey(keys: string | Array<string>): void {
    try {
      let arr;
      if (this.typeFn.isArray(keys)) {
        arr = keys;
      } else if (this.typeFn.isString(keys) && keys === 'all') {
        // localStorage.clear();
      } else if (this.typeFn.isString(keys)) {
        arr = [keys];
      } else {
        console.log('传入格式不对', keys);
        return;
      }

      arr.forEach((key) => {
        if (isPlatformBrowser(this.platformId)) {
          // 仅在浏览器运行;
          localStorage.removeItem(key);
        } else if (isPlatformServer(this.platformId)) {
          // 仅在服务端运行;
          this.globalCacheService[key] = null;
        }
      });
    } catch (error) {
      console.log('getLocalStorageByKey', {keys, error});
    }
  }


  // 设置 sessionStorage
  setSessionStorageByKey(key: string, value: any): void {
    try {
      if (isPlatformBrowser(this.platformId)) {
        // 仅在浏览器运行;
        sessionStorage.setItem(key, JSON.stringify(value));
      } else if (isPlatformServer(this.platformId)) {
        // 仅在服务端运行;
        this.globalCacheService[key] = value;
      }
    } catch (error) {
      console.log('setSessionStorageByKey', {key, value, error});
    }
  }

  // 获取 sessionStorage
  getSessionStorageByKey(key, defaultValue = null): any {
    try {
      if (isPlatformBrowser(this.platformId)) {
        // 仅在浏览器运行;
        return this.utilService.getJSONParse(sessionStorage.getItem(key) || defaultValue, defaultValue);
      } else if (isPlatformServer(this.platformId)) {
        // 仅在服务端运行;
        return this.globalCacheService[key] || defaultValue;
      }
    } catch (error) {
      console.log('getSessionStorageByKey', {key, error});
    }
  }

  /**
   * 删除 sessionStorage
   * @param keys 支持删除多个  传入 'all' 则删除全部
   *
   */
  removeSessionStorageByKey(keys: string | Array<string>): void {
    try {
      let arr;
      if (this.typeFn.isArray(keys)) {
        arr = keys;
      } else if (this.typeFn.isString(keys) && keys === 'all') {
        // sessionStorage.clear();
      } else if (this.typeFn.isString(keys)) {
        arr = [keys];
      } else {
        console.log('传入格式不对', keys);
        return;
      }

      arr.forEach((key) => {
        if (isPlatformBrowser(this.platformId)) {
          // 仅在浏览器运行;
          sessionStorage.removeItem(key);
        } else if (isPlatformServer(this.platformId)) {
          // 仅在服务端运行;
          this.globalCacheService[key] = null;
        }
      });
    } catch (error) {
      console.log('removeSessionStorageByKey', {keys, error});
    }
  }

}
